export default __webpack_public_path__ + "d05b429a7a0b4e8aa5fe63e5f246a7c8.png";